'use strict'

/**
 * @type {String}
 * @description The default title for new blocks
 */
const defaultTitle = 'Lorem ipsum'

/**
 * @type {String}
 * @description The default text for a new button
 */
const defaultButtonText = 'Button'

/**
 * @type {String}
 * @description The default link for a new button
 */
const defaultButtonLink = 'https://example.com'

/**
 * @type {String}
 * @description The default target for a new button
 */
const defaultButtonTarget = '_blank'

/**
 * @type {String}
 * @description The default image for a new image content block
 */
const defaultImage =
  'https://res.cloudinary.com/big-top/image/upload/f_auto/' +
  'v1601653954/system-v2/layout-builder/images/placeholder.png'

/**
 * @type {String}
 * @description The default image for a new image content block
 */
const defaultImageSquare =
  'https://res.cloudinary.com/big-top/image/upload/f_auto/' +
  'v1602495096/system-v2/layout-builder/images/placeholder-square.png'

/**
 * @type {String}
 * @description The base url for the social icons
 */
const baseSocialUrl =
  'https://res.cloudinary.com/big-top/image/upload/v1576498016/misc/socials/'

/**
 * @type {String}
 * @description The default content for a new block
 */
const defaultContent =
  '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod' +
  ' tempor incididunt ut labore et dolore magna aliqua.</p>'

/**
 * @type {String}
 * @description The default content for a new block
 */
const defaultHtmlContent = `<span style="display: block; background-color: MintCream; font-size: 18px; padding: 10px;">
  For emails to display consistently, styles need to be
  <span style="color: LightSeaGreen; font-style: italic;">inline, like this</span>
</span>`

/**
 * @type {String}
 * @description The default content for a new HTML content block
 */
const defaultHTMLContent = defaultHtmlContent

/**
 * @type {Object}
 * @description Default spacing options for the templates
 */
const defaultSpacing = {
  top: 10,
  right: 10,
  bottom: 10,
  left: 10,
}

/**
 * @type {Object}
 * @description Default spacing options for a block in the template
 */
const defaultBlockOptions = {
  background: '#ffffff',
  spacing: defaultSpacing,
  flushSpacing: false,
  columnAlignment: 'top',
}

/**
 * @type {Object}
 * @description Default overall styles for the email template.
 */
const defaultTemplateStyles = {
  background: '#f3f3f3',
  emailBackground: 'rgba(255,255,255,0)',
  headingsFont: 'Arial, Helvetica, sans-serif',
  bodyFont: 'Arial, Helvetica, sans-serif',
}

/**
 * @type {Object}
 * @description Default overall options for the email template.
 */
const defaultTemplateOpts = {
  linkTracking: true,
  signature: {
    enabled: true,
  },
}

/**
 * @type {Object}
 * @description Default overall styles for the email template.
 */
const defaultTitleOptions = {
  color: '#353535',
  size: 20,
  align: 'left',
}

/**
 * @type {Object}
 * @description Default overall styles for the email template.
 */
const defaultTextOptions = {}

/**
 * @type {Object}
 * @description Default overall styles for the email template.
 */
const defaultImageOptions = {
  align: 'center',
  size: 100,
}

/**
 * @type {Object}
 * @description Default overall styles for the email template.
 */
const defaultDividerOptions = {
  borderStyle: 'solid',
  borderWidth: 1,
  borderColor: 'rgb(222, 222, 222)',
  height: 20,
}

/**
 * @type {Object}
 * @description Default overall styles for the email template.
 */
const defaultButtonOptions = {
  borderRadius: 10,
  textColor: '#ffffff',
  color: '#353535',
  alignment: 'left',
  size: 12,
}

const alignmentOptions = [
  {
    label: 'Left',
    value: 'left',
  },
  {
    label: 'Center',
    value: 'center',
  },
  {
    label: 'Right',
    value: 'right',
  },
]

/**
 * @type {Array}
 * @description This is the configuration for the column widths
 */
const columns = {
  oneColumn: [600, 1],
  twoColumn: [
    [300, 0.5],
    [300, 0.5],
  ],
  threeColumn: [
    [200, 0.333],
    [200, 0.333],
    [200, 0.333],
  ],
  twoThirdsLeft: [
    [400, 0.666],
    [200, 0.333],
  ],
  twoThirdsRight: [
    [200, 0.333],
    [400, 0.666],
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * header block via the drag and drop.
 */
const headerTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1575544348/layout-builder/blocks-previews/modular/header.png',
  settings: {
    ...defaultBlockOptions,
    columnAlignment: 'middle',
  },
  type: 'twoThirdsRight',
  title: 'Header',
  content: [
    [
      {
        src:
          'https://res.cloudinary.com/big-top/image/upload/c_fill,q_auto,dpr_auto,' +
          'f_auto/v1505404706/layout-builder/default-logo-dark.png',
        type: 'image',
        style: {
          ...defaultImageOptions,
        },
      },
    ],
    [
      {
        content: '<p style="text-align: right;">Lorem ipsum dolor sit amet</p>',
        type: 'text',
      },
    ],
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * one column block via the drag and drop.
 */
const htmlColumnTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1550834640/layout-builder/blocks-previews/modular/1-col.png',
  settings: { ...defaultBlockOptions, flushSpacing: true },
  type: 'oneColumn',
  title: 'Custom HTML',
  content: [
    {
      content: defaultHTMLContent,
      type: 'html',
    },
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * one column block via the drag and drop.
 */
const oneColumnTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1550834640/layout-builder/blocks-previews/modular/1-col.png',
  settings: { ...defaultBlockOptions },
  type: 'oneColumn',
  title: '1 Column',
  content: [
    {
      content: defaultContent,
      type: 'text',
    },
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * two column block via the drag and drop.
 */
const twoColumnTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1550834641/layout-builder/blocks-previews/modular/2-col.png',
  settings: { ...defaultBlockOptions },
  type: 'twoColumn',
  title: '2 Columns',
  content: [
    [
      {
        content: defaultContent,
        type: 'text',
      },
    ],
    [
      {
        content: defaultContent,
        type: 'text',
      },
    ],
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * two thirds left column block via the drag and drop.
 */
const twoThirdsLeftColumnTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1550834641/layout-builder/blocks-previews/modular/2-col-large.png',
  settings: { ...defaultBlockOptions },
  type: 'twoThirdsLeft',
  title: '2 Columns - Large Left',
  content: [
    [
      {
        content: defaultTitle,
        type: 'title',
        style: {
          ...defaultTitleOptions,
        },
      },
      {
        content: defaultContent,
        type: 'text',
      },
    ],
    [
      {
        src: defaultImageSquare,
        type: 'image',
        style: {
          ...defaultImageOptions,
        },
      },
    ],
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * two thirds right column block via the drag and drop.
 */
const twoThirdsRightColumnTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1550834641/layout-builder/blocks-previews/modular/2-col-large-rev.png',
  settings: { ...defaultBlockOptions },
  type: 'twoThirdsRight',
  title: '2 Columns - Large Right',
  content: [
    [
      {
        src: defaultImageSquare,
        type: 'image',
        style: {
          ...defaultImageOptions,
        },
      },
    ],
    [
      {
        content: defaultTitle,
        type: 'title',
        style: {
          ...defaultTitleOptions,
        },
      },
      {
        content: defaultContent,
        type: 'text',
      },
    ],
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * three column block via the drag and drop.
 */
const threeColumnTemplate = {
  preview:
    'https://res.cloudinary.com/big-top/image/upload/v1550834641/layout-builder/blocks-previews/modular/3-col.png',
  settings: { ...defaultBlockOptions },
  type: 'threeColumn',
  title: '3 Columns',
  content: [
    [
      {
        content: defaultContent,
        type: 'text',
      },
    ],
    [
      {
        content: defaultContent,
        type: 'text',
      },
    ],
    [
      {
        content: defaultContent,
        type: 'text',
      },
    ],
  ],
}

/**
 * @type {Object}
 * @description This is the template object for creating a new
 * via the drag and drop.
 */
// const footerColumnTemplate = {
//   preview:
//     'https://res.cloudinary.com/big-top/image/upload/v1550834641/layout-builder/blocks-previews/modular/1-col.png',
//   settings: { ...defaultBlockOptions },
//   type: 'oneColumn',
//   title: 'Footer',
//   content: [
//     {
//       content:
//         '<div style="text-align: center; font-size: 12px">Sent by [[GLOBAL;ACCOUNT]] • Your Organisation\'s Address</div>',
//       type: 'text'
//     }
//   ]
// }

export const defaultFonts = [
  {
    label: 'Arial',
    value: 'Arial, Helvetica, sans-serif',
  },
  {
    label: 'Arial Black',
    value: "'Arial Black', Gadget, sans-serif",
  },
  {
    label: 'Lucida Sans',
    value: "'Lucida Sans Unicode', 'Lucida Grande', sans-serif",
  },
  {
    label: 'Tahoma',
    value: 'Tahoma, Geneva, sans-serif',
  },
  {
    label: 'Trebuchet',
    value: "'Trebuchet MS', Helvetica, sans-serif",
  },
  {
    label: 'Verdana',
    value: 'Verdana, Geneva, sans-serif',
  },
  {
    label: 'Georgia',
    value: 'Georgia, serif',
  },
  {
    label: 'Palatino',
    value: "'Palatino Linotype', 'Book Antiqua', Palatino, serif",
  },
  {
    label: 'Times',
    value: "'Times New Roman', Times, serif",
  },
  {
    label: 'Courier',
    value: "'Courier New', Courier, monospace",
  },
]

/**
 * @type {Object}
 * @description This is the main configuration for the akero
 * ui components, we get the config from here in all of the
 * components, as this can be extended when installing the
 * akero components into vue
 */
let config = {
  facebook: {
    default: `${baseSocialUrl}facebook-default-grey.png`,
    filled: `${baseSocialUrl}facebook-filled-grey.png`,
    outline: `${baseSocialUrl}facebook-outline-grey.png`,
  },
  blocks: [
    headerTemplate,
    oneColumnTemplate,
    twoColumnTemplate,
    twoThirdsLeftColumnTemplate,
    twoThirdsRightColumnTemplate,
    threeColumnTemplate,
    htmlColumnTemplate,
    // footerColumnTemplate
  ],
  alignmentOptions,
  columns,
  defaultTemplateStyles,
  defaultTemplateOpts,
  defaultBlockOptions,
  defaultSpacing,
  defaultContent,
  defaultTitle,
  defaultButtonText,
  defaultButtonLink,
  defaultButtonTarget,
  defaultImage,
  defaultTitleOptions,
  defaultTextOptions,
  defaultButtonOptions,
  defaultDividerOptions,
  defaultImageOptions,
  defaultHTMLContent,
}

/**
 * @param {Object} options
 * @description Overrides the default options with a new
 * configuration object
 */
export const setOptions = (options) => {
  config = options
}

export { config as default }
